<!--
 * @Author: yindengli
 * @Date: 2023-06-26 11:04:28
 * @LastEditTime: 2023-06-27 10:26:24
 * @LastEditors: yindengli
 * @Description: 
 * @FilePath: \openseeyon-index-front\src\components\FaqCmp\home\HotTabContent.vue
-->
<template>
  <div class="hot-tab-content-box">
    <div v-if="tagList.length === 0" class="hot-no-content">暂无数据</div>
    <template v-else>
        <a-tag v-for="(item, index) in tagList" :key="index" :title="item.content" class="hot-label" color="blue" @click="searchItem(item.content)">{{ item.content}}</a-tag> 
    </template>
  </div>
</template>

<script>
export default {
  name: 'hotTabContent',
  props: {
    tagList: { type: Array, default: ()=> [] }
  },
  components: {
  },
  data() {
    return {
    };
  },
  computed:{
  },
  watch:{
  },
  methods: {
    // 点击某一项热搜或推荐时，发送点击值进行搜索操作
    searchItem(content) {
        this.$emit("searchItem", content)
    },
  },
  created  () {},
  mounted  () {}
};
</script>

<style scoped lang="scss">
.hot-tab-content-box {
    width: 100%;
    min-height: 100px;
    // &>span:not(:nth-child(1)) {
    //     margin-left: 10px;
    // }
    // &>span:nth-child(10n + 0) {
    //     margin-left: 0px;
    // }
    &>span {
      margin-left: 20px;
    }
    .hot-no-content {
      font-size: 14px;
      color: #ddd;
      text-align: center;
      height: 100px;
      line-height: 100px;
    }
    .hot-label {
        display: inline-block;
        text-align: center;
        font-size: 14px;
        color: #000;
        margin-top: 20px;
        cursor: pointer;
    }

}


</style>
